import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  Subject,
  switchMap,
} from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule, DatePipe } from "@angular/common";
import buildQuery from "odata-query";
import {
  AddInventoryPurchasePOHeaderWithLineDto,
  InventoryPurchaseOrderHeaderAddressDto,
} from "../../../core/models/inventoryPurchases/InventoryPurchaseHeaderLineDto";
import { InventoryPurchaseService } from "../../../core/services/inventory-purchase.service";
import { OwnerList } from "../../../core/models/inventoryPurchases/ownerListDto";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { GetBacForSalesOrderDto } from "../../../core/models/orders/getBacForSalesOrderDto";
import { StockPhrase } from "../../../core/models/orders/stockPhrase";
import { Address } from "../../../core/models/shared/address";
import { City } from "../../../core/models/shared/cityList";
import { AddressCountryRegion } from "../../../core/models/shared/countryRegionList";
import { AddressCounty } from "../../../core/models/shared/countyList";
import { Currency } from "../../../core/models/shared/currencyList";
import { District } from "../../../core/models/shared/districtList";
import { ExchangeRatesDto } from "../../../core/models/shared/exchangeRateDto";
import { ReleasedProduct } from "../../../core/models/shared/releaseProduct";
import { ShippingMethod } from "../../../core/models/shared/shippingMethod";
import { AddressState } from "../../../core/models/shared/stateList";
import { UsersList } from "../../../core/models/users/users/usersList";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { GetAllVendorsDto } from "../../../core/models/vendor/getAllVendors";
import { AddNewClientService } from "../../../core/services/add-new-client.service";
import { LoaderService } from "../../../core/services/loader.service";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { StockPhrasesComponent } from "../../../shared/components/stock-phrases/stock-phrases.component";
import { ClientPurpose } from "../../../shared/enums/clientPurpose";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { SamplepoShipToAddressComponent } from "../../samplePo/components/samplepo-ship-to-address/samplepo-ship-to-address.component";
import { UserManagementService } from "../../../core/services/user-management.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ClientSearchList } from "../../../core/models/shared/clientSearchList";
import { Table, TableModule } from "primeng/table";
import { DatePickerModule } from "primeng/datepicker";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { GetBCForSalesOrderDto } from "../../../core/models/orders/getBCForSalesOrderDto";
import { InventoryPurchaseShipToAddressComponent } from "../inventory-purchase-ship-to-address/inventory-purchase-ship-to-address.component";
import { GetVendorSearchResponseDto } from "../../../core/models/vendor/getVendorSearchResponseDto";
import { Scroller } from "primeng/scroller";
import { SamplePOForm } from "../../../core/models/inventoryPurchases/inventoryPurchaseForm.dto";
import { Popover, PopoverModule } from "primeng/popover";
import { ItemsSecurity } from "../../../core/models/samplePO/details/itemsSecurity";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { computeMinDate } from "../../../core/utilities/mindate-function";

interface AddressFormData {
  addressInformation: {
    countryRegionIdD365: string | null;
    cityD365: string | null;
    stateD365: string | null;
  };
}
@UntilDestroy()
@Component({
  selector: "jni-inventory-purchase-header",
  templateUrl: "./inventory-purchase-header.component.html",
  styleUrls: ["./inventory-purchase-header.component.scss"],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    DatePickerModule,
    SelectModule,
    InventoryPurchaseShipToAddressComponent,
    Scroller,
    PopoverModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    ToggleSwitchModule,
    FormsModule,
  ],
})
export class InventoryPurchaseHeaderComponent implements OnInit {
  shipDateCurrentdate = computeMinDate();
  inHandDateCurrentdate = computeMinDate();
  currentDate = new Date();
  shipDate = new Date().toISOString();
  inHandDate = new Date().toISOString();
  legalName = "";
  shipToAddress = false;
  vendorAccountAndBook = false;
  firmOneCheckBox = false;
  bcUserDefaultSelectionId = 0;
  bcList: UsersList[] = [];
  bacList: GetBacForSalesOrderDto[] = [];
  samplePOForm: FormGroup;
  showSmallLoader = false;
  countryRegionSelectedId = "";
  countryRegionList: AddressCountryRegion[] = [];
  getFilteredZipCode: string[] = [];
  getZipCode: string[] = [];
  cityList: City[] = [];
  stateSelectedId = "";
  stateList: AddressState[] = [];
  districtList: District[] = [];
  countyList: AddressCounty[] = [];
  addressValidationStatus = true;
  customerBillToObject?: ClientSearchList;
  shiftToAddressList!: Address[];
  vendorAccountSeletion = "";
  brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  currencyList: Currency[] = [];
  addressBookName = "";
  vendorAccountNumber = "";
  brandingConsultantObject!: GetBCForSalesOrderDto;
  currencyObject?: ExchangeRatesDto;
  currencyConversion?: ExchangeRatesDto;
  showZip = true;
  showDistrict = false;
  showPostBox = false;
  showCity = false;
  showCounty = false;
  showState = false;
  showStreetNumber = false;
  showStreet = true;
  showbuildingComplement = false;
  showAddressBook = false;
  showAppartment = false;
  showAddressValidation = false;
  showValidateAddress = false;
  showForeignCurrency = false;
  showAddress = false;
  displayPosition = false;
  displayPositionDescription = false;
  displayPositionFactory = false;
  position = "bottom-right";
  closable = false;
  displayModal = false;
  importUserRights = true;
  customerCheckbox = true;
  vendorCheckbox = true;
  customerId = "";
  userRoleId = 0;

  vendorList: GetVendorSearchResponseDto[] = [];
  clientLists: ClientSearchList[] = [];
  addressBookList: Address[] = [];
  shiftToAddressField = "";
  releasedProductsList: ReleasedProduct[] = [];
  shippingProductsList: ShippingMethod[] = [];
  stockListing: StockPhrase[] = [];
  filerStockListing: StockPhrase[] = [];
  selectedAccountNumber = "";
  isAddressValidationButton = true;
  netValueWithIcon = "";
  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netConvertToUsd = "";
  netTotalPrice = "";
  netTotalPriceConverted = "";
  userPersonnelNumber!: string;
  vendorDisplayModal = false;

  public searchVendor$ = new Subject<string>();
  public searchClient$ = new Subject<string>();
  creatSamplePoObject?: AddInventoryPurchasePOHeaderWithLineDto;

  @ViewChild("stockPhraseDescription", { static: false })
  stockPhraseDescription!: StockPhrasesComponent;

  @ViewChild("stockPhraseFactory", { static: false })
  stockPhraseFactory!: StockPhrasesComponent;

  @ViewChild("samplepoaddress", { static: false })
  samplepoaddress!: SamplepoShipToAddressComponent;

  @ViewChild("clientdt") table!: Table;

  deliveryAddress = [
    {
      id: 3,
      name: "Vendor",
      status: false,
    },
    {
      id: 5,
      name: "One Time",
      status: false,
    },
    {
      id: 6,
      name: "One Time Blank",
      status: false,
    },
  ];

  // addressField!: {
  //   deliveryAddressfield: "deliveryAddressDescription";
  //   countryRegionfield: "countryRegionIdD365";
  //   addressFormatField: "addressFormat";
  //   addressLine2Field: "addressLine2";
  //   addressLine3Field: "addressLine3";
  //   cityD365Field: "cityD365";
  //   stateD365Field: "stateD365";
  //   zipCodeD365Field: "zipCodeD365";
  //   streetD365Field: "streetD365";
  //   attentionInformationD365Field: "attentionInformationD365";
  //   locationD365Field: "locationD365";
  //   addressD365Field: "addressD365";
  //   isPrimaryD365Field: "isPrimaryD365";
  //   validateAddressField: "validateAddress";
  //   shipToEmail: "shipToEmail";
  // };
  addressField = {
    deliveryAddressfield: "deliveryAddressDescription",
    countryRegionfield: "countryRegionIdD365",
    addressFormatField: "addressFormat",
    addressLine2Field: "addressLine2",
    addressLine3Field: "addressLine3",
    cityD365Field: "cityD365",
    stateD365Field: "stateD365",
    zipCodeD365Field: "zipCodeD365",
    streetD365Field: "streetD365",
    attentionInformationD365Field: "attentionInformationD365",
    locationD365Field: "locationD365",
    addressD365Field: "addressD365",
    isPrimaryD365Field: "isPrimaryD365",
    validateAddressField: "validateAddress",
    shipToEmail: "shipToEmail",
  };
  owner_list: OwnerList[] = [
    {
      name: "DG",
      value: "RH-JNICore",
      description: "Red Hat - JNI Core",
      store: "REDHAT",
    },
    {
      name: "DG",
      value: "RH-Global",
      description: "RED HAT - GLOBAL STORE",
      store: "REDHAT",
    },
    {
      name: "DG",
      value: "BOOZALLEN",
      description: "BOO960",
      store: "BOOZALLEN",
    },
  ];

  filtered_owner_list: OwnerList[] = [];
  sitewarehouseMapper: Record<string, string> = {
    CA: "DG",
    DG: "CA",
    JNI: "JNI",
  };
  siteField = [
    {
      id: 1,
      name: "JNI",
    },
    {
      id: 2,
      name: "CA",
    },
  ];

  storesField = [
    {
      id: 1,
      name: "REDHAT",
      clientAccNumber: "81004914",
      clientPartyNumber: "PTY000019712",
    },
    {
      id: 2,
      name: "BOOZALLEN",
      clientAccNumber: "81015306",
      clientPartyNumber: "PTY000037130",
    },
  ];

  filteredStoresField = [
    {
      id: 1,
      name: "REDHAT",
      clientAccNumber: "81004914",
      clientPartyNumber: "PTY000019712",
    },
    {
      id: 2,
      name: "BOOZALLEN",
      clientAccNumber: "81015306",
      clientPartyNumber: "PTY000037130",
    },
  ];

  userRole = 0;
  enumUserRole = UserRole;

  selectedStore!: string;

  productSecurity = {} as ItemsSecurity;

  warehouseField = [
    {
      id: 1,
      name: "DG",
    },
    {
      id: 2,
      name: "JNI",
    },
  ];

  inventoryPOSummary!: InventoryPurchaseOrderHeaderAddressDto;
  inventoryPONumber!: string;
  inventoryPurchCheck = true;

  constructor(
    private _router: ActivatedRoute,
    private _samplepoListingService: SamplepoListingService,
    private _inventoryPurchaseService: InventoryPurchaseService,
    private _addNewClientService: AddNewClientService,
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private route: Router,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private _profileFormService: ProfileFormService,
    private _loginService: UserManagementService,
    public datepipe: DatePipe
  ) {
    this._router.params.subscribe(params => {
      this.inventoryPONumber = params["samplePONumber"];
      if (this.inventoryPONumber?.toLowerCase()?.includes("temp")) {
        //this.isValidSamplePONumber = false;
      } else {
        //this.isValidSamplePONumber = true;
      }
    });
    this.samplePOForm = this._formBuilder.group({
      header: this._formBuilder.group({
        orderVendorAccountNumberD365: ["", [Validators.required]],
        vendorAccountNumber: ["", [Validators.required]],
        jobNameD365: [
          "",
          [
            Validators.minLength(2),
            Validators.maxLength(150),
            Validators.required,
          ],
        ],
        customerRef365: [""],
        expectedStoreAvailableSalesDateD365: [""],
        expectedStoreReceiptDateD365: ["", [Validators.required]],
        firm: [false],
        inventoryPurchaseD365: [true],
        clientProspectNumber: [""],
        brandingConsultantIdD365: ["", [Validators.required]],
        bAC: [""],
        accountCoordinatorD365: [""],
        vendorName: [""],
        vendorAddress: [""],
        vendorPhone: [""],
        vendorEmail: [""],
        deliveryModeIdD365: [""],
        accountNumber: [""],
        currencyCodeD365: [{ value: "", disabled: true }],
        shipToDeliveryAddressList: [""],
        siteD365: [""],
        warehouseD365: ["", [Validators.required]],
        storeD365: ["", [Validators.required]],
        ownerD365: ["", [Validators.required]],
        isnetInForeignCurrencyStatus: [{ value: false, disabled: true }],
      }),
      addressInformation: this._formBuilder.group({
        attentionInformationD365: [""],
        locationD365: [""],
        deliveryAddressDescription: ["", Validators.required],
        countryRegionIdD365: ["", Validators.required],
        zipCodeD365: [{ value: "", disabled: true }],
        cityD365: [{ value: "", disabled: true }],
        stateD365: [{ value: "", disabled: true }],
        addressD365: [""],
        streetD365: [""],
        purposeD365: ClientPurpose.Business,
        isPrimaryD365: "1",
        shipToEmail: [""],
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        addressLocationNumberD365: [0],
        validateAddress: [""],
        addressFormat: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: [""],
      }),
      // lines: this._formBuilder.group({
      //   id: [0],
      //   itemNumberD365: ['', Validators.required],
      //   externalItemNumberD365: ['', Validators.required],
      //   orderedPurchaseQuantityD365: ['', Validators.required],
      //   requestedShippingDateD365: [''],
      //   requestedDeliveryDateD365: [''],
      //   rsmFirmD365: [false],
      //   purchasePriceD365: [''],
      //   lineAmountD365: [0],
      //   netConversion: [0],
      //   netConversionTotal: [0],
      //   lineDescriptionD365: [
      //     '',
      //     [Validators.minLength(1), Validators.maxLength(2000)]
      //   ],
      //   factoryNotesD365: [
      //     '',
      //     [Validators.minLength(1), Validators.maxLength(2000)]
      //   ],

      //   rates: [0]
      // })
    });
    this.incrementInHandCurrentDate();
  }

  formErrors: Record<string, string> = {
    vendorAccountNumber: "",
    orderVendorAccountNumberD365: "",
    brandingConsultantIdD365: "",
    orderedPurchaseQuantityD365: "",
    externalItemNumberD365: "",
    itemNumberD365: "",
    jobNameD365: "",
    deliveryAddressDescription: "",
    countryRegionIdD365: "",
    deliveryNameD365: "",
    shipToEmail: "",
    storeD365: "",
    expectedStoreReceiptDateD365: "",
    warehouseD365: "",
    ownerD365: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    vendorAccountNumber: {
      required: "3PL is required.",
    },
    storeD365: {
      required: "Store is required.",
    },
    ownerD365: {
      required: "Owner is required.",
    },
    warehouseD365: {
      required: "Warehouse is required.",
    },
    expectedStoreReceiptDateD365: {
      required: "In-hands date is required.",
    },
    jobNameD365: {
      minlength: "Job name must contain 2 characters.",
      maxlength: "Job name must contain 150 characters.",
      required: "Job name is required.",
    },
    orderVendorAccountNumberD365: {
      required: "3PL is required.",
    },
    brandingConsultantIdD365: {
      required: "Branding consultant is required.",
    },
    orderedPurchaseQuantityD365: {
      required: "Quantity is required.",
    },
    externalItemNumberD365: {
      required: "Vendor sku is required.",
    },
    itemNumberD365: {
      required: "Category is required.",
    },
    deliveryAddressDescription: {
      required: "Delivery address is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
  };

  ngOnInit(): void {
    this.getInventoryPOSummary(this.inventoryPONumber);
    this.getUserProfile();
    this.getCurrencyListData();
    this.disabledVendorsFields();
    this.disableHeaderInfo();
    // this.disabledCountryAndStreetFields();
    this.getCountryRegionListData();
    this.getAllShippingMethod();
    this.getAllReleaseProduct();
    this.disabledInitialFields();
    this.getAllBcUsers();
    this.searchVendorName();
    this.searchClientName();
    this.getWhoISupport();
    this.supportRoles();
    this.samplePOForm.valueChanges.subscribe(data => {
      this.addressValidation(data);
    });
  }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  disabledInitialFields() {
    //this.samplePOForm.get(['lines', 'lineAmountD365'])?.disable();
    this.samplePOForm.get(["header", "currencyCodeD365"])?.disable();
    //this.samplePOForm.get(['lines', 'purchasePriceD365'])?.disable();
    // this.samplePOForm.get(['lines', 'netConversion'])?.disable();
    // this.samplePOForm.get(['lines', 'netConversionTotal'])?.disable();
  }

  disableHeaderInfo() {
    this.samplePOForm.get(["header", "siteD365"])?.disable();
    this.samplePOForm.get(["header", "warehouseD365"])?.disable();
  }
  // async zipCodeSearchFilter(event: any) {
  //   this.selectedZipCode(event.value);
  // }
  onVendorModal() {
    const vendorAccount = this.samplePOForm.get([
      "header",
      "orderVendorAccountNumberD365",
    ])?.value;
    if (vendorAccount) {
      this.vendorDisplayModal = true;
    }
  }

  closeModal() {
    this.vendorDisplayModal = false;
  }

  onCurrencyEnable(event: Event) {
    if (event) {
      this.samplePOForm.get(["header", "currencyCodeD365"])?.enable();
      //this.samplePOForm.get(['lines', 'purchasePriceD365'])?.disable();
      this.clearCurrencyCodeRecordAndNetInForeignCurrency();
      this.showForeignCurrency = true;
    } else {
      this.samplePOForm.get(["header", "currencyCodeD365"])?.disable();
      // this.samplePOForm.get(['lines', 'purchasePriceD365'])?.enable();
      this.clearCurrencyCodeRecordAndNetInForeignCurrency();
      this.currencyConversion = undefined;
      this.showForeignCurrency = false;
    }
  }

  clearCurrencyCodeRecordAndNetInForeignCurrency() {
    this.samplePOForm.patchValue({
      header: {
        currencyCodeD365: "",
      },
      // lines: {
      //   purchasePriceD365: '',
      //   lineAmountD365: '',
      //   netConversion: '',
      //   netConversionTotal: ''
      // }
    });
  }

  logValidationErrors(group: FormGroup = this.samplePOForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  validateAddress() {
    this.showSmallLoader = true;
    const address = "usa ca street 1";
    this._addNewClientService
      .checkAddressValidation(address)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.data == true) {
            this.samplePOForm
              .get(["addressInformation", "addressD365"])
              ?.clearValidators();
            this.samplePOForm
              .get(["addressInformation", "addressD365"])
              ?.updateValueAndValidity();
            this.addressValidationStatus = false;
          }
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  addressValidation(data: AddressFormData) {
    const addressObj = data.addressInformation;
    if (
      addressObj.countryRegionIdD365 &&
      addressObj.cityD365 &&
      addressObj.stateD365
    ) {
      this.isAddressValidationButton = false;
      this.samplePOForm
        .get(["addressInformation", "addressD365"])
        ?.setValidators(Validators.required);
    } else {
      this.isAddressValidationButton = true;
    }
  }

  clearValidationOnAddress() {
    this.samplePOForm
      .get(["addressInformation", "addressD365"])
      ?.clearValidators();
    this.samplePOForm
      .get(["addressInformation", "addressD365"])
      ?.updateValueAndValidity();
  }

  applyValidationOnAddress() {
    this.samplePOForm
      .get(["addressInformation", "addressD365"])
      ?.setValidators(Validators.required);
    this.samplePOForm
      .get(["addressInformation", "addressD365"])
      ?.updateValueAndValidity();
  }

  onCurrencyConversion() {
    this.showSmallLoader = true;
    const currency = this.samplePOForm.get([
      "header",
      "currencyCodeD365",
    ])?.value;
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });
      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            const sortedCurrency = res.data.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });
            this.currencyConversion = sortedCurrency[0];
            if (this.currencyConversion) {
              // this.patchValueInRates(this.currencyConversion.Rate.toString());
            }
            //this.samplePOForm.get(['lines', 'purchasePriceD365'])?.enable();
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  // patchValueInRates(rates: string) {
  //   // this.samplePOForm.patchValue({
  //   //   lines: {
  //   //     rates: parseFloat(rates)
  //   //   }
  //   // });
  // }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.shippingProductsList = res.data;
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
        },
      });
  }

  getAllReleaseProduct() {
    this._samplepoListingService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsList = res.data.filter(
            item => item.poStopped === "No"
          );
        },
      });
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  // onBrandingConsultantSelection(event: any) {
  //   //this.showSmallLoader = true;
  //   // this.patchValueInBacField(event.personnelNumber)
  //   this.patchValueInBrandingConsultant(event.personnelNumber);
  //   event.open();
  //   // this._samplepoListingService
  //   //   .getAllBrandingConsultant()
  //   //   .pipe(untilDestroyed(this))
  //   //   .subscribe({
  //   //     next: (res: any) => {
  //   //       if (res.data != null) {
  //   //         this.brandingConsultantLists = res.data;
  //   //       }
  //   //       this.showSmallLoader = false;
  //   //     },
  //   //     error: () => {
  //   //       this.showSmallLoader = false;
  //   //     }
  //   //   });
  // }

  getAllBcUsers() {
    // this._samplepoListingService
    //   .getAllBrandingConsultant()
    //   .pipe(untilDestroyed(this))
    //   .subscribe({
    //     next: (res: any) => {
    //       if (res.data != null) {
    //         this.brandingConsultantLists = res.data;
    //         if (this.brandingConsultantLists) {
    //           if (this.brandingConsultantLists.length > 0) {
    //             this.brandingConsultantObject = this.brandingConsultantLists[0];
    //             this.patchValueInBrandingConsultant(
    //               this.brandingConsultantLists[0]
    //             );
    //             this.getBACList(res.data[0].personnelNumber);
    //           }
    //         }
    //       }
    //       this.showSmallLoader = false;
    //     },
    //     error: () => {
    //       this.showSmallLoader = false;
    //     }
    //   });
  }

  patchValueInBrandingConsultant(data: string) {
    this.samplePOForm.patchValue({
      header: {
        brandingConsultantIdD365: data,
      },
    });
  }

  onProjectIdSelection(event: GetBCForSalesOrderDto, dropdown: Popover) {
    this.brandingConsultantObject = event;
    this.getBacForSalesOrder(event.personnelNumber);
    this.patchProjectIdInBCField(event);
    dropdown.hide();
    const deliveryAddress = this.samplePOForm.get([
      "addressInformation",
      "deliveryAddressDescription",
    ])?.value;
    if (deliveryAddress === "Branding Consultant") {
      this.clearAllShifToForm();
      this.samplepoaddress?.clearAllShifToForm();
      this.brandingConsultantObject = event;
      this.samplepoaddress?.patchBrandingConsultantName();
    }
  }

  patchProjectIdInBCField(event: GetBCForSalesOrderDto) {
    this.samplePOForm.patchValue({
      header: {
        brandingConsultant: event.projectId,
      },
    });
  }

  // onVendorAddressBookSelect(event: any) {
  //   if (this.addressBookList?.length > 1) {
  //     event.open();
  //   } else {
  //     event.close();
  //   }
  // }

  onVendorRowSelection(
    vendorSelectedRow: GetAllVendorsDto,
    vendorToggle: Popover
  ) {
    this.showSmallLoader = true;
    this.clearVendorForm();
    const partyNumber = vendorSelectedRow.partyNumber;
    const accountNumber = vendorSelectedRow.vendorAccountNumber;
    const currency = vendorSelectedRow.currency;
    this._samplepoListingService
      .getVendorAddressByPartyNumber(partyNumber, accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          const primaryAddress = res.data.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );
          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInVendorFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          }
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
    this.patchValuesInVendorForm(vendorSelectedRow);
    this.patchAccountNumber(accountNumber ?? "");
    this.patchVendorCurrency(currency);
    vendorToggle.hide();
  }

  patchAccountNumber(acountNumber: string) {
    this.vendorAccountNumber = acountNumber;
    this.vendorCheckbox = false;

    this.samplePOForm.patchValue({
      header: {
        orderVendorAccountNumberD365: acountNumber,
      },
    });
  }

  onOwnerDropDownChange(event: SelectChangeEvent | string) {
    this.filtered_owner_list = this.owner_list.filter(
      item => item.store == (typeof event !== "string" ? event?.value : event)
    );
    const storeData = this.storesField.find(
      item => item.name === (typeof event !== "string" ? event?.value : event)
    );
    this.samplePOForm.patchValue({
      header: {
        ownerD365: this.filtered_owner_list[0]?.value,
        warehouseD365: "DG",
        siteD365: "CA",
      },
    });
    if (storeData) {
      this.getBCForSalesOrder(storeData.clientAccNumber);
    }
  }

  supportRoles() {
    this._samplepoListingService
      .supportRoles()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.productSecurity = res.data;
          this.filterStores();
        },
      });
  }

  filterStores() {
    if (this.userRole !== this.enumUserRole.Admin) {
      this.filteredStoresField = [];
      if (this.productSecurity && Object.keys(this.productSecurity).length) {
        if (this.productSecurity.redHat) {
          this.filteredStoresField = this.storesField.filter(
            x => x.name == "REDHAT"
          );
        }

        if (this.productSecurity.boozAllen) {
          const boozProducts = this.storesField.filter(
            x => x.name == "BOOZALLEN"
          );
          this.filteredStoresField.push(...boozProducts);
        }

        if (this.filteredStoresField?.length) {
          this.samplePOForm.patchValue({
            header: {
              storeD365: this.filteredStoresField[0].name,
            },
          });

          this.onOwnerDropDownChange(this.filteredStoresField[0].name);
        }
      }
    }
  }

  patchVendorCurrency(currency: string) {
    this.samplePOForm.patchValue({
      header: {
        currencyCodeD365: currency,
      },
    });
  }

  // onClientSelection(event: any, clientProspetToggle: any) {
  //   const name = event.organizationNameD365;
  //   this.selectedAccountNumber = event.clientAccount;
  //   this.customerBillToObject = event;
  //   this.samplePOForm.patchValue({
  //     header: {
  //       clientProspectNumber: name,
  //       deliveryModeIdD365: event.shippingMethod,
  //       accountNumber: event.salesAccountNumberD365,
  //     },
  //   });
  //   this.onShippingMethodSelect(event.shippingMethod);
  //   if (event.name != "") {
  //     this.deliveryAddress[0].status = false;
  //     this.deliveryAddress[1].status = false;
  //   } else {
  //     this.deliveryAddress[0].status = true;
  //     this.deliveryAddress[1].status = true;
  //   }
  //   if (this.selectedAccountNumber) {
  //     this.customerId = this.selectedAccountNumber;
  //     if (this.customerId) {
  //       this.customerCheckbox = false;
  //     }
  //   }
  //   this.getBCForSalesOrder(event.clientAccount);

  //   const deliveryAddress = this.samplePOForm.get([
  //     "addressInformation",
  //     "deliveryAddressDescription",
  //   ])?.value;
  //   if (
  //     deliveryAddress === "Bill To" ||
  //     deliveryAddress === "Customer Address Book" ||
  //     deliveryAddress === "Branding Consultant"
  //   ) {
  //     this.clearAllShifToForm();
  //     this.samplepoaddress?.clearAllShifToForm();
  //   }

  //   clientProspetToggle.close();
  // }

  getBCForSalesOrder(accountNumber: string) {
    this.selectedAccountNumber = accountNumber.toString() || "";
    this._samplepoListingService
      .getBCForSalesOrder(accountNumber ?? "")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetBCForSalesOrderDto[]>) => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;
            if (this.brandingConsultantLists.length > 0) {
              this.brandingConsultantObject = this.brandingConsultantLists[0];
              this.patchValueInBrandingConsultant(
                this.brandingConsultantLists[0].personnelNumber
              );
            } else {
              this.patchValueInBrandingConsultant("");
            }
            this.getBacForSalesOrder(
              this.brandingConsultantObject?.personnelNumber
            );
          }
        },
      });
  }

  getBacForSalesOrder(personnelNumber: string) {
    this._samplepoListingService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.bacList = res.data;
            const defaultSelection =
              this.bacList.find(x => x.isPrimary)?.personnelNumber ??
              this.bacList[0]?.personnelNumber ??
              "";
            this.patchValueInBacField(defaultSelection);
          }
        },
      });
  }

  patchValueInBacField(personnelNumber: string) {
    this.samplePOForm.patchValue({
      header: {
        accountCoordinatorD365: personnelNumber,
      },
    });
  }

  clearVendorForm() {
    this.samplePOForm.patchValue({
      header: {
        vendorName: "",
        vendorPhone: "",
        vendorEmail: "",
        vendorAddress: "",
      },
    });
  }

  patchClientAccountNumber(accountNumber: string) {
    this.samplePOForm.patchValue({
      header: {
        accountNumber: accountNumber,
      },
    });
  }

  clearClientAccountNumber() {
    this.samplePOForm.patchValue({
      header: {
        accountNumber: [""],
      },
    });
  }

  // onclientSelection(event: any, client: any) {
  //   const clientname = event.target.value;
  //   if (clientname == "") {
  //     this.deliveryAddress[0].status = true;
  //     this.deliveryAddress[1].status = true;
  //     this.clearClientAccountNumber();
  //   }
  //   if (clientname != "" && clientname != undefined) {
  //     client.open();
  //     this._samplepoListingService
  //       .getClientAndProspectByNameAndAccountNumberFilter(clientname)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res: GenericResponseDto<ClientSearchList[]>) => {
  //           if (res.data != null) {
  //             this.clientLists = res.data;
  //           }
  //           this.showSmallLoader = false;
  //         },
  //         error: () => {
  //           this.showSmallLoader = false;
  //         },
  //       });
  //   }
  // }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  patchValuesInVendorFormAddressField(address: string) {
    this.samplePOForm.patchValue({
      header: {
        vendorAddress: address,
      },
    });
  }

  patchValuesInVendorForm(vendorSelectedRow: GetAllVendorsDto) {
    this.samplePOForm.patchValue({
      header: {
        vendorName: vendorSelectedRow.vendorName,
        vendorPhone: vendorSelectedRow.phoneNumber,
        vendorEmail: vendorSelectedRow.emailAddress,
      },
    });
  }

  searchVendorName() {
    this.searchVendor$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }
          const accountNumberOrName = searchitem;
          this.vendorList = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._samplepoListingService.getVendorByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<GetVendorSearchResponseDto[]>) => {
          if (res.data != null) {
            this.vendorList = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onVendorSearchOpenToggle(mydrop: Popover) {
    mydrop.hide();
  }

  searchClientName() {
    this.searchClient$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }
          const clientname = searchitem;
          if (clientname == "") {
            this.deliveryAddress[0].status = true;
            this.deliveryAddress[1].status = true;
            this.clearClientAccountNumber();
            const deliveryAddress = this.samplePOForm.get([
              "addressInformation",
              "deliveryAddressDescription",
            ])?.value;

            if (
              deliveryAddress === "Bill To" ||
              deliveryAddress === "Customer Address Book"
            ) {
              this.clearAllShifToForm();
              this.samplepoaddress?.clearAllShifToForm();
            }
          } else {
            return this._samplepoListingService.getClientAndProspectByNameAndAccountNumberFilter(
              clientname
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<ClientSearchList[]>) => {
          if (res.data != null) {
            this.clientLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  disabledAddressFields() {
    // this.samplePOForm
    //   .get(['addressInformation', 'countryRegionIdD365'])
    //   ?.disable();
    this.samplePOForm.get(["addressInformation", "zipCodeD365"])?.disable();
    this.samplePOForm.get(["addressInformation", "streetD365"])?.disable();
  }

  disabledVendorsFields() {
    this.samplePOForm.get(["header", "vendorName"])?.disable();
    this.samplePOForm.get(["header", "vendorAddress"])?.disable();
    this.samplePOForm.get(["header", "vendorPhone"])?.disable();
    this.samplePOForm.get(["header", "vendorEmail"])?.disable();
  }

  // onDeliveryAddressChange(event: string, shipaddress: any) {
  //   if (event === "Bill To") {
  //     this.shipToAddress = false;
  //     this.vendorAccountAndBook = false;
  //     this.showAddressValidation = false;
  //     this.showValidateAddress = false;
  //     this.patchAddressOfCustomerBillTo();
  //     this.clearValidationOnAddress();
  //     this.hiddenAddressFields();
  //     this.clearShifToForm();
  //   } else if (event === "Customer Address Book") {
  //     this.shipToAddress = true;
  //     this.vendorAccountAndBook = false;
  //     this.showAddressValidation = false;
  //     this.showValidateAddress = false;
  //     this.patchAddressOfCustomerAddressBook(shipaddress);
  //     this.clearValidationOnAddress();
  //     this.hiddenAddressFields();
  //     this.clearShifToForm();
  //   } else if (event === "Vendor") {
  //     this.shipToAddress = false;
  //     this.vendorAccountAndBook = true;
  //     this.showAddressValidation = false;
  //     this.showValidateAddress = false;
  //     this.clearValidationOnAddress();
  //     this.hiddenAddressFields();
  //     this.clearShifToForm();
  //   } else if (event === "Branding Consultant") {
  //     this.shipToAddress = false;
  //     this.vendorAccountAndBook = false;
  //     this.showAddressValidation = false;
  //     this.showValidateAddress = false;
  //     this.patchAddressOfBrandingConsultant();
  //     this.clearValidationOnAddress();
  //     this.hiddenAddressFields();
  //     this.clearShifToForm();
  //   } else {
  //     this.shipToAddress = false;
  //     this.vendorAccountAndBook = false;
  //     this.showAddressValidation = true;
  //     this.showValidateAddress = true;
  //     this.applyValidationOnAddress();
  //     if (event !== "One Time") {
  //       this.clearShifToForm();
  //     }
  //     if (event === "One Time") {
  //       this.clearValidationOnAddress();
  //     }
  //   }
  //   this.enableCountryField(event);
  // }

  hiddenAddressFields() {
    this.showDistrict = false;
    this.showPostBox = false;
    this.showCity = false;
    this.showCounty = false;
    this.showState = false;
    this.showStreetNumber = false;
    this.showbuildingComplement = false;
    this.showAddressBook = false;
    this.showAppartment = false;
  }
  clearShifToForm() {
    this.samplePOForm.patchValue({
      addressInformation: {
        // countryRegionIdD365: '',
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  clearAllShifToForm() {
    this.samplePOForm.patchValue({
      addressInformation: {
        deliveryAddressDescription: "",
        countryRegionIdD365: "",
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  patchAddressOfCustomerBillTo() {
    this.showSmallLoader = true;
    if (
      this.customerBillToObject?.partyNumber != undefined ||
      this.customerBillToObject?.clientAccount != undefined
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(
          this.customerBillToObject?.partyNumber,
          this.customerBillToObject?.clientAccount
        )
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res.data != null) {
              const primaryAddress = res.data.filter(
                x =>
                  x.isPrimaryD365?.toLowerCase() === "yes" ||
                  x.isPrimaryD365?.toLowerCase() === "1"
              );
              if (primaryAddress.length > 0) {
                this.patchFormInShipToAddressField(primaryAddress[0]);
              }
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  // patchAddressOfCustomerAddressBook(shipaddress: any) {
  //   this.showSmallLoader = true;
  //   if (
  //     this.customerBillToObject?.partyNumber != undefined ||
  //     this.customerBillToObject?.clientAccount != undefined
  //   ) {
  //     this._samplepoListingService
  //       .getVendorAddressByPartyNumber(
  //         this.customerBillToObject?.partyNumber,
  //         this.customerBillToObject?.clientAccount
  //       )
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: res => {
  //           this.showSmallLoader = false;
  //           if (res.data != null) {
  //             this.shiftToAddressList = res.data;
  //             shipaddress.open();
  //             //this.patchFormInShipToAddressField(res.data[0]);
  //           }
  //         },
  //         error: res => {
  //           this.showSmallLoader = false;
  //         },
  //       });
  //   }
  // }

  patchAddressOfBrandingConsultant() {
    this.showSmallLoader = true;
    const partyNumber = this.brandingConsultantObject?.partyNumber;
    if (partyNumber != undefined) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(partyNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res.data != null) {
              this.patchFormInShipToAddressField(res.data[0]);
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
    this.showSmallLoader = false;
  }

  // onShitToAddressSeletion(event: any, shipAddressToggle: Popover) {
  //   shipAddressToggle.hide();

  //   if (event.addressD365 != "") {
  //     this.shiftToAddressField = event.addressD365;
  //   }
  //   this.patchFormInShipToAddressField(event);
  // }

  patchFormInShipToAddressField(address: Address) {
    if (address) {
      this.samplePOForm.patchValue({
        addressInformation: {
          countryRegionIdD365: address.countryRegionIdD365,
          zipCodeD365: address.zipCodeD365,
          streetD365: address.streetD365,
          cityD365: address.cityD365,
          stateD365: address.stateD365,
          countyD365: address.countyD365,
          streetNumberD365: address.streetNumberD365,
          buildingComplimentD365: address.buildingComplimentD365,
          apartment_RUD365: address.apartment_RUD365,
          postBoxD365: address.postBoxD365,
          districtNameD365: address.districtNameD365,
          addressLocationNumber: parseInt(address.locationNumberD365 ?? "0"),
          addressD365: address.addressD365,
        },
      });
    }
  }

  enableCountryField(event: string) {
    if (event === "One Time" || event === "One Time Blank") {
      this.samplePOForm
        .get(["addressInformation", "countryRegionIdD365"])
        ?.enable();
      this.samplePOForm.get(["addressInformation", "streetD365"])?.enable();
    } else {
      this.samplePOForm
        .get(["addressInformation", "countryRegionIdD365"])
        ?.disable();
      this.samplePOForm.get(["addressInformation", "streetD365"])?.disable();
    }
  }

  disabledCountryAndStreetFields() {
    // this.samplePOForm
    //   .get(['addressInformation', 'countryRegionIdD365'])
    //   ?.disable();
    // this.samplePOForm.get(['addressInformation', 'streetD365'])?.disable();
  }

  onshipToAddressFilter(drop: Popover) {
    drop.hide();
  }

  // vendorAccountFilter(event: any, drop: any) {
  //   const vendorAccountNumber = event.target.value;
  //   if (vendorAccountNumber != undefined && vendorAccountNumber != "") {
  //     drop.open();
  //     this._samplepoListingService
  //       .getVendorByNameAndAccountNumberFilter(event.target.value)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res) => {
  //           if (res.data != null) {
  //             this.vendorList = res.data;
  //           }
  //         },
  //       });
  //   } else {
  //     drop.close();
  //   }
  // }

  // onVendorAccountSelection(
  //   event: any,
  //   vendorAccount: any,
  //   vendoraddressbook: any
  // ) {
  //   this.clearShifToForm();
  //   this.vendorAccountSeletion = event.vendorName;
  //   const partyNumber = event.partyNumber;
  //   if (
  //     this.vendorAccountSeletion != undefined &&
  //     this.vendorAccountSeletion != ""
  //   ) {
  //     this._samplepoListingService
  //       .getVendorAddressByPartyNumber(partyNumber)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res: any) => {
  //           if (res.data != null) {
  //             this.addressBookList = res.data;
  //             if (this.addressBookList.length === 1) {
  //               this.onVendorAddressBookSelection(
  //                 this.addressBookList[0],
  //                 vendorAccount
  //               );
  //             }
  //             if (this.addressBookList?.length > 1) {
  //               vendoraddressbook.open();
  //             } else {
  //               vendoraddressbook.close();
  //             }
  //           }
  //         },
  //       });
  //   }
  //   vendorAccount.close();
  // }

  // onVendorAddressBookSelection(event: any, vendorAddressBookToggle: any) {
  //   this.addressBookName = event.addressD365;
  //   this.samplePOForm.patchValue({
  //     addressInformation: {
  //       countryRegionIdD365: event.countryRegionIdD365,
  //       zipCodeD365: event.zipCodeD365,
  //       streetD365: event.streetD365,
  //       cityD365: event.cityD365,
  //       stateD365: event.stateD365,
  //       countyD365: event.countyD365,
  //       streetNumberD365: event.streetNumberD365,
  //       buildingComplimentD365: event.buildingComplimentD365,
  //       apartment_RUD365: event.apartment_RUD365,
  //       postBoxD365: event.postBoxD365,
  //       districtNameD365: event.districtNameD365,
  //       addressLocationNumber: parseInt(event.locationNumberD365),
  //       addressD365: event.addressD365,
  //     },
  //   });
  //   vendorAddressBookToggle?.close();
  // }

  incrementInHandCurrentDate() {
    this.inHandDateCurrentdate.setDate(this.shipDateCurrentdate.getDate() + 1);
  }
  onShipDateSelection(event: Date) {
    // this.shipDate = event;
    // this.shipDateOne = new Date(event).toLocaleDateString();
    const shipDate = new Date(event);
    this.shipDate = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    const dateCheck = this.datepipe.transform(Date.now(), "MM/dd/yyyy") ?? "";
    if (this.shipDate) {
      if (dateCheck == this.shipDate) {
        this.incrementInHandCurrentDate();
      } else {
        this.inHandDateCurrentdate = computeMinDate(this.shipDate, false);
      }
    } else {
      this.incrementInHandCurrentDate();
    }
    this.samplePOForm.patchValue({
      header: {
        expectedStoreAvailableSalesDateD365: this.shipDate,
      },
    });
  }

  getConvertedInHandDate(inHandDate: string) {
    if (inHandDate) {
      return new Date(inHandDate);
    } else {
      return new Date();
    }
  }

  onInHandDateSelection(event: Date) {
    // this.inHandDate = event;
    // this.inHandDateOne = new Date(event).toLocaleDateString();
    const inHandDate = new Date(event);
    this.inHandDate = this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    this.samplePOForm.patchValue({
      header: {
        expectedStoreReceiptDateD365: this.inHandDate,
      },
    });
  }

  // onShipDateOneSelection(event: any) {
  //   this.shipDateOne = event.target.value;
  // }

  // onInHandDateOneSelection(event: any) {
  //   this.inHandDateOne = event.target.value;
  // }

  // onFirmChange(event: any) {
  //   this.firmOneCheckBox = event.target.checked;
  //   // this.samplePOForm.patchValue({
  //   //   lines: {
  //   //     rsmFirmD365: this.firmOneCheckBox
  //   //   }
  //   // });
  // }

  // getBACList(id: number) {
  //   this._addNewClientService
  //     .getBACList(id)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.bacList = res.data;
  //         // const obj = this.bacList.filter((x) => x.isPrimary == true);
  //         // if (obj.length > 0) {
  //         //   this.bacUserDefaultSelectionId = obj[0].personnelNumber;
  //         // }
  //       },
  //     });
  // }

  // onCountryRegionSelection(countryid: string) {
  //   if (countryid) {
  //     this.samplePOForm.get(['addressInformation', 'zipCodeD365'])?.enable();
  //     this.samplePOForm.get(['addressInformation', 'cityD365'])?.enable();
  //     this.samplePOForm.get(['addressInformation', 'stateD365'])?.enable();
  //   } else {
  //     this.samplePOForm.get(['addressInformation', 'zipCodeD365'])?.disable();
  //     this.samplePOForm.get(['addressInformation', 'cityD365'])?.disable();
  //     this.samplePOForm.get(['addressInformation', 'stateD365'])?.disable();
  //   }

  //   const countryregionid = countryid != null ? countryid : '';
  //   if (countryregionid == '') {
  //     this.cityList != null ? (this.cityList.length = 0) : null;
  //     this.stateList != null ? (this.stateList.length = 0) : null;
  //     this.addressValidationStatus = true;
  //     this.updateValueOnCountrySelection();
  //   } else {
  //     this.updateValueOnCountrySelection();
  //     this.filterAddressFormats(countryregionid);
  //     this.getCountyListData(countryregionid);
  //     this.getStateListData(countryregionid);
  //   }
  // }

  filterAddressFormats(countryId: string) {
    const filteredRegions = this.countryRegionList.filter(
      x => x.countryRegionD365 == countryId
    );
    this.getAddressFormats(filteredRegions[0].addressFormatD365);
  }
  getAddressFormats(formatId: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getAddressFormatsByFormatId(formatId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.filterAddressesUsingAddressFormats(res?.data?.descriptionD365);
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }
  filterAddressesUsingAddressFormats(description: string | null) {
    if (
      !description?.toLowerCase().includes("zip") &&
      !description?.toLowerCase().includes("postal_code") &&
      !description?.toLowerCase().includes("postcode") &&
      !description?.toLowerCase().includes("postal code")
    ) {
      this.showZip = false;
    } else {
      this.showZip = true;
    }
    if (!description?.toLowerCase().includes("district")) {
      this.showDistrict = false;
    } else {
      this.showDistrict = true;
    }
    if (!description?.toLowerCase().includes("city")) {
      this.showCity = false;
    } else {
      this.showCity = true;
    }
    if (!description?.toLowerCase().includes("county")) {
      this.showCounty = false;
    } else {
      this.showCounty = true;
    }
    if (
      !description?.toLowerCase().includes("state") &&
      !description?.toLowerCase().includes("province")
    ) {
      this.showState = false;
    } else {
      this.showState = true;
    }
    if (!description?.toLowerCase().includes("street")) {
      this.showStreet = false;
    } else {
      this.showStreet = true;
    }
    if (!description?.toLowerCase().includes("number")) {
      this.showStreetNumber = false;
    } else {
      this.showStreetNumber = true;
    }
    if (
      !description?.toLowerCase().includes("complement") &&
      !description?.toLowerCase().includes("building")
    ) {
      this.showbuildingComplement = false;
    } else {
      this.showbuildingComplement = true;
    }
    if (!description?.toLowerCase().includes("apartment")) {
      this.showAppartment = false;
    } else {
      this.showAppartment = true;
    }
    const poBox = description
      ?.toLowerCase()
      .split(",")
      .join(" ")
      .split("/")
      .join(" ")
      .split("_")
      .join(" ")
      .split(";")
      .join(" ")
      .split(" ")
      .some(x => x == "post" || x == "postbox");
    if (!poBox) {
      this.showPostBox = false;
    } else {
      this.showPostBox = true;
    }
  }

  updateValueOnCountrySelection() {
    this.samplePOForm.patchValue({
      addressInformation: {
        zipCodeD365: "",
        districtNameD365: "",
        cityD365: "",
        countyD365: "",
        stateD365: "",
      },
    });
  }

  getStateListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getStateList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.stateList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  // addShifDateInLines(samplePoDto: any) {
  //   // if (
  //   //   samplePoDto['lines'].requestedShippingDateD365 == '' ||
  //   //   samplePoDto['lines'].requestedDeliveryDateD365 == ''
  //   // ) {
  //   //   samplePoDto['lines'].requestedShippingDateD365 =
  //   //     this.shipDateOne.toString();
  //   //   samplePoDto['lines'].requestedDeliveryDateD365 =
  //   //     this.inHandDateOne.toString();
  //   // }
  // }

  addShifDateInHeader(samplePoDto: SamplePOForm) {
    if (
      samplePoDto.header.expectedStoreAvailableSalesDateD365 == "" ||
      samplePoDto.header.expectedStoreReceiptDateD365 == ""
    ) {
      samplePoDto.header.expectedStoreAvailableSalesDateD365 =
        this.shipDate.toString();
      samplePoDto.header.expectedStoreReceiptDateD365 =
        this.inHandDate.toString();
    }
  }

  addAddressInHeader(samplePoDto: SamplePOForm) {
    if (samplePoDto.addressInformation) {
      samplePoDto.header.attentionInformationD365 =
        samplePoDto.addressInformation.attentionInformationD365 ?? "";
      samplePoDto.header.locationD365 =
        samplePoDto.addressInformation.locationD365 ?? "";

      samplePoDto.header.deliveryAddressDistrictNameD365 =
        samplePoDto.addressInformation.districtNameD365 ?? "";

      samplePoDto.header.emailD365 =
        samplePoDto.addressInformation.shipToEmail ?? "";

      samplePoDto.header.deliveryAddressDescription =
        samplePoDto.addressInformation.deliveryAddressDescription ?? "";

      if (this.shiftToAddressField != "") {
        samplePoDto.header.shipToDeliveryAddressList = this.shiftToAddressField;
      }

      if (this.addressBookName != "") {
        samplePoDto.header.vendorAddress = this.addressBookName;
      }
    }
  }

  removeUsedVendorFields(samplePoDto: SamplePOForm) {
    delete samplePoDto.header.vendorName;
    delete samplePoDto.header.vendorPhone;
    delete samplePoDto.header.vendorEmail;
  }

  // patchValuesInLinesPrice(samplePoDto: any) {
  //   // samplePoDto['lines'].lineAmountD365 = this.netTotalPrice;
  //   // samplePoDto['lines'].netConversion = this.netConvertToUsd;
  //   // samplePoDto['lines'].netConversionTotal = this.netTotalPriceConverted;
  // }

  onShippingMethodSelect(shippingMethodCode: SelectChangeEvent) {
    const index = this.shippingProductsList.findIndex(
      x => x.modeCodeD365 == shippingMethodCode.value
    );
    if (index > -1) {
      const selectedShippingMethod = this.shippingProductsList[index];
      if (
        selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes"
      ) {
        this.samplePOForm.patchValue({
          header: {
            accountNumber: selectedShippingMethod.jniFreightAcctNumD365,
          },
        });
      } else {
        this._addNewClientService
          .getClientFreightAccountNumber(this.selectedAccountNumber)
          .subscribe({
            next: res => {
              if (res.data) {
                this.samplePOForm.patchValue({
                  header: {
                    accountNumber: res.data,
                  },
                });
              } else {
                this.samplePOForm.patchValue({
                  header: {
                    accountNumber: "",
                  },
                });
              }
            },
            error: () => {
              this.samplePOForm.patchValue({
                header: {
                  accountNumber: "",
                },
              });
            },
          });
      }
    }
  }

  submitButtonlogValidationErrors(group: FormGroup = this.samplePOForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  onSelectionChange(event: SelectChangeEvent, type: string) {
    if (type === "warehouse") {
      this.samplePOForm.patchValue({
        header: {
          siteD365: this.sitewarehouseMapper[`${event.value}`],
        },
      });
    } else {
      this.samplePOForm.patchValue({
        header: {
          warehouseD365: this.sitewarehouseMapper[`${event.value}`],
        },
      });
    }
    this.samplePOForm.patchValue({
      header: {
        ownerD365: "",
      },
    });
    this.filtered_owner_list = this.owner_list.filter(
      item =>
        item.name === this.samplePOForm.get(["header", "warehouseD365"])?.value
    );
  }

  addSamplePoScreen() {
    this.submitButtonlogValidationErrors();
    this._loaderService.setLoaderState(true);
    const samplePoDto = this.samplePOForm.getRawValue();
    // this.addShifDateInLines(samplePoDto);
    //this.addShifDateInHeader(samplePoDto);
    this.removeUsedVendorFields(samplePoDto);
    //this.patchValuesInLinesPrice(samplePoDto);
    //const samplePoLine = [];
    //samplePoLine.push(samplePoDto['lines']);
    this.addAddressInHeader(samplePoDto);
    samplePoDto.header.clientProspectNumber = this.selectedAccountNumber;
    const shipDateHeader =
      samplePoDto.header.expectedStoreAvailableSalesDateD365;
    const inHandDateHeader = samplePoDto.header.expectedStoreReceiptDateD365;

    if (shipDateHeader && inHandDateHeader) {
      if (new Date(inHandDateHeader) < new Date(shipDateHeader)) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date header greater and equal to ship date header"
        );
        return;
      }
    }

    if (!samplePoDto.header.expectedStoreAvailableSalesDateD365) {
      samplePoDto.header.expectedStoreAvailableSalesDateD365 = "";
    }

    if (!samplePoDto.header.expectedStoreReceiptDateD365) {
      samplePoDto.header.expectedStoreReceiptDateD365 = "";
    }

    // const shipDateLine = samplePoDto['lines'].requestedShippingDateD365;
    // const inHandDateLine = samplePoDto['lines'].requestedDeliveryDateD365;

    // if (shipDateLine && inHandDateLine) {
    //   if (new Date(inHandDateLine) < new Date(shipDateLine)) {
    //     this._loaderService.setLoaderState(false);
    //     this._toastr.error(
    //       'Error',
    //       'Inhands date line greater and equal to ship date line'
    //     );
    //     return;
    //   }
    // }

    // if (!samplePoDto['lines'].requestedShippingDateD365) {
    //   samplePoDto['lines'].requestedShippingDateD365 = '';
    // }

    // if (!samplePoDto['lines'].requestedDeliveryDateD365) {
    //   samplePoDto['lines'].requestedDeliveryDateD365 = '';
    // }

    if (samplePoDto.header.firm != undefined) {
      if (samplePoDto.header.firm === true) {
        samplePoDto.header.firm = "YES";
      } else {
        samplePoDto.header.firm = "NO";
      }
    }

    // if (samplePoDto['lines'].firm != undefined) {
    //   if (samplePoDto['lines'].firm === true) {
    //     samplePoDto['lines'].firm = 'YES';
    //   } else {
    //     samplePoDto['lines'].firm = 'NO';
    //   }
    // }

    // if (samplePoDto['lines'].orderedPurchaseQuantityD365 === 0) {
    //   this._toastr.error('Error', 'Quantity must be greater than zero');
    //   this._loaderService.setLoaderState(false);
    //   return;
    // }

    if (!this.samplePOForm.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }

    if (samplePoDto.addressInformation?.deliveryNameD365) {
      samplePoDto.header.deliveryNameD365 =
        samplePoDto.addressInformation.deliveryNameD365;
    }
    if (samplePoDto.addressInformation?.shipToEmail) {
      samplePoDto.header.shipToEmail =
        samplePoDto.addressInformation.shipToEmail;
    }

    const purchaseOrderHeaderAddressDto = {
      purchaseOrderHeader: samplePoDto.header,
      address: samplePoDto.addressInformation,
    };

    if (purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
      purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryAddressD365 =
        this.getDeliveryAddress(
          purchaseOrderHeaderAddressDto.purchaseOrderHeader
            .deliveryAddressDescription || "",
          purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryNameD365 ||
            "",
          purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryNameD365 ||
            ""
        );
    }
    this.creatSamplePoObject = {
      purchaseOrderHeaderAddressDto: purchaseOrderHeaderAddressDto,
      //purchaseOrderLines: samplePoLine
    };

    this._inventoryPurchaseService
      .addInventoryPO(this.creatSamplePoObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data != null) {
            this._toastr.success(
              "Success",
              "Inventory purchases added successfully"
            );
            this.route.navigate([
              `inventory-purchase/inventory-purchase-lines/${res.data.PurchaseOrderId}`,
            ]);
            // const url = `/samplepo/samplepo-summary/${res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader?.purchaseOrderNumberD365}`;
            // this.route.navigate([url]);
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error adding Inventory purchases"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding Sample PO");
        },
      });
  }

  showAddressComponent() {
    const deliveryAddress = this.samplePOForm.get([
      "addressInformation",
      "deliveryAddressDescription",
    ])?.value as string;
    if (deliveryAddress?.toLowerCase().includes("one")) {
      this.samplePOForm.get(["addressInformation", "addressD365"])?.enable();
      this.showAddress = false;
      return true;
    } else {
      this.samplePOForm.get(["addressInformation", "addressD365"])?.disable();
      this.showAddress = true;
      return false;
    }
  }

  getDescription(event: StockPhrase[]) {
    let description = "";
    event.forEach(element => {
      if (element.description) {
        if (description == "") {
          description += element.description;
        } else {
          description += "\n" + element.description;
        }
      }
    });

    this.samplePOForm.patchValue({
      lines: {
        lineDescriptionD365: description,
      },
    });
    this.closePositionDialogDescription();
  }

  getFactory(event: StockPhrase[]) {
    let fact = "";
    event.forEach(element => {
      if (element.notes) {
        if (fact == "") {
          fact += element.notes;
        } else {
          fact += "\n" + element.notes;
        }
      }
    });

    this.samplePOForm.patchValue({
      lines: {
        factoryNotesD365: fact,
      },
    });
    this.closePositionDialogFactory();
  }

  showPositionDialogDescription(position: string) {
    this.position = position;
    this.displayPositionDescription = true;
    this.stockPhraseDescription.flag = "description";
    this.stockPhraseDescription.selectedStock = [];
    this.stockPhraseDescription.getStockPhraseData();
  }

  showPositionDialogFactory(position: string) {
    this.position = position;
    this.displayPositionFactory = true;
    this.stockPhraseFactory.flag = "factory";
    this.stockPhraseFactory.selectedStock = [];
    this.stockPhraseFactory.getStockPhraseData();
  }

  closePositionDialogDescription() {
    this.displayPositionDescription = false;
  }

  closePositionDialogFactory() {
    this.displayPositionFactory = false;
  }
  onCancel() {
    this.route.navigate(["/inventory-purchase/inventory-purchase-listing"]);
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        this.filterStores();
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res.data != null) {
          this.userPersonnelNumber = res.data.personnelNumber;
          //this.patchValueInBc();
        }
      },
    });
  }

  patchValueInBc() {
    if (this.userPersonnelNumber && this.brandingConsultantLists.length > 0) {
      const filterBacObject = this.brandingConsultantLists?.filter(
        x => x.personnelNumber === this.userPersonnelNumber
      );
      if (filterBacObject?.length > 0) {
        this.brandingConsultantObject = filterBacObject[0];
        this.patchValueInBrandingConsultant(filterBacObject[0].personnelNumber);
        this.getBacForSalesOrder(filterBacObject[0].personnelNumber);
      } else {
        if (this.brandingConsultantLists.length > 0) {
          this.brandingConsultantObject = this.brandingConsultantLists[0];
          this.patchValueInBrandingConsultant(
            this.brandingConsultantLists[0].personnelNumber
          );
          this.getBacForSalesOrder(
            this.brandingConsultantLists[0].personnelNumber
          );
        }
      }
    }
  }

  getDeliveryAddress(
    addressSelectionName: string,
    deliveryNameD365: string,
    shipToVendorAccountNameD365: string
  ) {
    if (addressSelectionName.toLowerCase().includes("one")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("bill")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      return shipToVendorAccountNameD365;
    } else if (addressSelectionName.toLowerCase().includes("address")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("branding")) {
      return deliveryNameD365;
    }
    return "";
  }

  getWhoISupport() {
    this._samplepoListingService
      .getAllWhoISupport()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }
  private getInventoryPOSummary(inventoryPONumber: string) {
    this._loaderService.setLoaderState(true);
    this._inventoryPurchaseService
      .getInventoryPOSummary(inventoryPONumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          // const odataFilter = `?$filter=ID eq '${samplePONumber}'`;
          // this._orderSummaryService
          //   .GetJNIDeletedRecordsFilter(odataFilter)
          //   .subscribe();
          this.inventoryPOSummary = res.data;
          if (res.data) {
            // this.bindFormControls();
            // if (res.data?.purchaseOrderHeaderAddressDto) {
            //   this.initializePurchaseOrderHeader(
            //     res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader,
            //     res.data?.purchaseOrderHeaderAddressDto?.address
            //   );
            // }
            // this.initializeVendor(res.data.vendor);
            // this.initializeVendorAddress(res.data.vendorAddress);
            // this.initializeVendorContact(res.data.vendorContact);
            // if (
            //   res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
            //     ?.purchaseOrderStatusD365
            // ) {
            //   this.purchaseOrderStatus =
            //     res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader?.purchaseOrderStatusD365;
            // }
            // if (res.data.purchaseOrderLines) {
            //   this.initializeLine(res.data.purchaseOrderLines[0]);
            //   this.initalizeLinesArray(res.data.purchaseOrderLines);
            //   this.purchaseOrderLineList = res.data.purchaseOrderLines;
            //   if (
            //     res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
            //       ?.currencyCodeD365
            //   ) {
            //     this.getSellCurrencyConversion(
            //       res.data?.purchaseOrderHeaderAddressDto.purchaseOrderHeader
            //         ?.currencyCodeD365
            //     );
            //   }
            // }
            // if (res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
            //   this.getClientProspectIssues(
            //     res.data?.purchaseOrderHeaderAddressDto.purchaseOrderHeader
            //       .clientProspectNumber || ''
            //   );
            //   this.shippingDate = '';
            //   this.inHandsDate = '';
            //   this.clientProspectNumber =
            //     res.data?.purchaseOrderHeaderAddressDto.purchaseOrderHeader
            //       .clientProspectNumber || '';
            // }
            // if (this.clientProspectNumber) {
            //   this.customerId = this.clientProspectNumber;
            //   if (this.customerId) {
            //     this.customerCheckbox = false;
            //   }
            //   //this.getBCForSalesOrder(this.clientProspectNumber, '');
            //   this.getWhoISupport();
            // }
            // if (this.samplePOSummary?.vendor?.vendorAccountNumberD365) {
            //   this.vendorAccountNumber =
            //     this.samplePOSummary.vendor.vendorAccountNumberD365;
            //   if (this.vendorAccountNumber) {
            //     this.vendorCheckbox = false;
            //   }
            // }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }
}
